import LocalizationLanguageEn from "./LocalizationLanguageEn";
import LocalizationLanguageFi from "./LocalizationLanguageFi";
import LocalizedStrings, { LocalizedStringsMethods } from "react-localization";
import { GenderKeys } from "models/ResultPacket/Gender";
import { ActivityKeys } from "models/ResultPacket/Activity";
import { FirstLanguageKeys } from "models/ResultPacket/FirstLanguage";
import { EducationKeys } from "models/ResultPacket/Education";
import { FillReasonKeys } from "models/ResultPacket/FillReason";
import fin from 'images/flags/fin.png';
import eng from 'images/flags/eng.png';
import { Eula } from "./EulaFi";


export interface LocalizationStrings {
	lang_nativeName: string;
	lang_selectionName: string;
	lang_selectionTitle: string;
	lang_selectionAccept: string;

	home_title: string;
	home_description: string;
	home_description_link: string;
	home_startQuestionnaire_button: string;
	home_resultOpener_title: string;
	home_resultOpener_submit: string;
	home_resultOpener_error_invalidFormat: string;
	home_resultOpener_button: string;

	question_answerQuestion_error: string;
	question_help_title: string;

	button_next: string;
	button_previous: string;
	button_save: string;
	button_tryAgain: string;
	button_toHome: string;
	button_yes: string;
	button_no: string;
	button_start: string;
	button_cancel: string;
	button_send: string;
	button_copyUrl: string;
	button_copyCode: string;
	button_printPdf: string;
	button_exit: string;
	button_toSummary: string;
	button_close: string;
	button_endQuestionnaire: string;
	button_instructions: string;
	button_shareResult: string;
	button_openPicture: string;

	preliminary_title: string;
	preliminary_description: string;

	preliminary_form_answer_noAnswer: string;
	preliminary_form_other_text: string;

	preliminary_age_title: string;
	preliminary_answer_age_title: string;

	preliminary_gender_title: string;
	preliminary_answer_gender_title: string;
	preliminary_gender_choices: {
		[key in GenderKeys]: string;
	},

	preliminary_firstLanguage_title: string;
	preliminary_answer_firstLanguage_title: string;
	preliminary_firstLanguage_choices: {
		[key in FirstLanguageKeys]: string;
	},

	preliminary_education_title: string;
	preliminary_answer_education_title: string;
	preliminary_education_choices: {
		[key in EducationKeys]: string;
	};

	preliminary_activity_title: string;
	preliminary_answer_activity_title: string;
	preliminary_activity: {
		[key in ActivityKeys]: string
	};

	preliminary_fillReason_title: string;
	preliminary_answer_fillReason_title: string;
	preliminary_fillReason: {
		[key in FillReasonKeys]: string;
	};

	finish_sendResults: string;
	finish_noAnswer: string,

	finish_highlightError: string;

	error_result: string;
	error_result_notFound: string;
	error_generic: string;

	terms_title: string;
	terms_button_accept: string;

	reset_title: string;
	reset_body: string;

	start_description: string;
	endQuestionnaire_title: string;

	finish_title: string;
	finish_description: string;
	finish_description_start: string;

	finish_answers_title: string;

	finish_highlight: string;
	finish_unhighlight: string;

	resultSharing_title: string;
	resultSharing_survey: string;
	resultSharing_urlShare: string;
	resultSharing_codeShare: string;
	resultSharing_description: string;
	resultSharing_urlShare_copied: string;
	resultSharing_codeShare_copied: string;
	
	answers_target_title: string;
	answers_title: string;
	answers_answers_title: string;
	answers_resultCode: string;
	answers_resultCode_end: string;
	answers_secondary_answer_Value_texts: {
		[value: string]: string;
	};

	loading: string;
	sending: string;

	questionnaireList_choose_title: string;	
}

export interface LocalizationLanguage extends LocalizedStringsMethods, LocalizationStrings {
}

const storageKey = 'kuntoutussäätiö.l10n';

// export type LanguageCode = 'fi' | 'en' | 'sv' | 'ru';
// export type LanguageCode = 'fi' | 'en' | 'sv';
export type LanguageCode = 'fi' | 'en';

export const iconsPaths: { [key in LanguageCode]: string } = {
	'fi': fin,
	// 'sv': swe,
	'en': eng
}

export const EulaElement: { [key in LanguageCode]: any } = {
	'fi': Eula,
	'en': Eula
}

let l10n: LocalizationLanguage;

l10n = new LocalizedStrings({
	fi: LocalizationLanguageFi,
	en: LocalizationLanguageEn,
	//ru: LocalizationlanguageRu,
	// sv: LocalizationlanguageSe,

})


export function getStoredLanguage() {
	return localStorage.getItem(storageKey);
}

export function storeLangauge() {
	localStorage.setItem(storageKey, l10n.getLanguage());
}

export default l10n;

export function restoreFromLocalStorage() {
	const stored = localStorage.getItem(storageKey);
	if (stored) {
		l10n.setLanguage(stored);
	} else if (l10n.getLanguage() === 'en') {
		l10n.setLanguage('fi');
	}
}